<template>
	<div class="video-item overflow-hidden transition-shadow duration-300">
		<a :href="externalLink" target="_blank" v-if="externalLink?.length > 0">
			<div
				class="relative group image aspect-w-16 aspect-h-9 overflow-hidden rounded-lg"
			>
				<img :src="previewImageURL" class="object-cover rounded-lg" alt="" />
				<div
					class="absolute inset-0 flex items-center justify-center w-full h-full transition-colors duration-300 bg-gray-900 bg-opacity-0 group-hover:bg-opacity-40"
				>
					<div
						class="flex items-center justify-center w-8 h-8 transition duration-300 group-hover:scale-110"
					>
						<div class="play w-full h-full"></div>
					</div>
				</div>
			</div>
		</a>
		<router-link :to="url" v-if="!externalLink || externalLink?.length == 0">
			<!-- <a :href="url" aria-label="Article"> -->
			<div
				class="relative group image aspect-w-16 aspect-h-9 overflow-hidden rounded-lg"
			>
				<img :src="previewImageURL" class="object-cover rounded-lg" alt="" />
				<div
					class="absolute inset-0 flex items-center justify-center w-full h-full transition-colors duration-300 bg-gray-900 bg-opacity-0 group-hover:bg-opacity-40"
				>
					<div
						class="flex items-center justify-center w-8 h-8 transition duration-300 group-hover:scale-110"
					>
						<div class="play w-full h-full"></div>
					</div>
				</div>
			</div>
			<!-- </a> -->
		</router-link>
		<div class="pt-1 pb-1">
			<h3 class="title line-clamp-2" v-html="attributedTitle"></h3>
			<p class="desc line-clamp-2" v-if="showDesc">{{ desc }}</p>
			<div class="flex justify-between text-xs text-gray-500 items-center xs:mt-0.5 mt-2">
				<span v-if="itemData.published_at">{{ getTime(itemData.published_at) }}</span>
				<div class="flex space-x-1 md:space-x-2 items-center" v-if="itemData.counter">
					<span v-if="itemData.counter && itemData.counter.views">
						曝光<span class="pl-0.5">{{ getViews(itemData.counter.views) }}</span>
					</span>
					<span v-if="calculateInteraction(itemData.counter)">
						互动<span class="pl-0.5">{{ calculateInteraction(itemData.counter) }}</span>
					</span>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
export default {
	props: {
		desc: String,
		title: String,
		imageURL: String,
		videoThumbnailURL: String,
		url: String,
		date: String,
		externalLink: String,
		keywords: String,
		showDesc: {
			type: Boolean,
			default: false,
		},
		itemData: Object,
	},
	name: "VideoItem",
	components: {},
	data() {
		return {};
	},
	mounted() {
		// console.log(this.imageURL);
	},
	computed: {
		previewImageURL() {
			var previewURL = this.imageURL;
			if (
				previewURL?.length == 0 ||
				previewURL.endsWith("/assets/images/no-image.jpg")
			) {
				previewURL = this.videoThumbnailURL;
			}
			return previewURL;
		},
		attributedTitle() {
			let match = this.keywords?.trim();
			match = "新";
			if (match?.length > 0) {
				const regex = new RegExp("(" + match + ")", "g");
				return this.title.replace(regex, '<span class="highlight .highlight-search-result">$1</span>');
				// return this.title.replace;
			} else {
				return this.title;
			}
		},
		getViews () {
			return (views)=>{
				// 超过10000，使用万
				if (views > 10000) {
					return (views / 10000).toFixed(1) + "w";
				} else {
					return views;
				}
			}
		},
		calculateInteraction () {
            // return (counter)=>{
			// 	if (!counter) return 0;
			// 	return (counter.likes || 0) +
			// 		(counter.comments || 0) +
			// 		(counter.shares || 0) +
			// 		(counter.yes_help || 0) +
			// 		(counter.no_help || 0);
			// }
			return (interaction)=>{
				let sum = 0;
				sum += interaction.likes || 0;
				sum += interaction.comments || 0;
				sum += interaction.shares || 0;
				sum += interaction.yes_help || 0;
				sum += interaction.no_help || 0;
				if (sum > 10000) {
					return (sum / 10000).toFixed(1) + "w";
				} else {
					return sum;
				}
			}
        },
		getTime () {
			return (publishedAt)=>{
				// publishedAt "2023-09-23 01:29:18" 如果是今年，使用 yy-dd；其他年份：yyyy-mm-dd
				const year = publishedAt.split(" ")[0].split("-")[0];
				const month = publishedAt.split(" ")[0].split("-")[1];
				const day = publishedAt.split(" ")[0].split("-")[2];
				if (year == new Date().getFullYear()) {
					return `${month}-${day}`;
				} else {
					return `${year}-${month}-${day}`;
				}
			}
		}
	},
};
</script>

<style scoped>
.title {
	font-size: 13px;
	font-weight: 500;
	color: #111;
	height: 40px;
}
.desc {
	margin-top: 4px;
	font-size: 13px;
	font-weight: normal;
	line-height: 150%;
	color: #777;
}
.highlight-search-result {
	color: #cb3432 !important;
	margin: 0 1px;
}

.play {
	background-size: contain;
	background-image: url("~@/assets/images/icon-play.png");
}

img {
	background-color: lightgray;
	opacity: 0;
	border: none;
}

img[src^="http"] {
	display: block;
	background: none;
	opacity: 1;
}
img[lazy="loading"],
img[lazy="loaded"],
img[lazy="error"] {
	background-color: rgba(250, 250, 250, 20);
}

@media (min-width: 500px) {
	.title {
		font-size: 15px;
	}
	.desc {
		font-size: 14px;
	}
}
</style>
